import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = {
  key: 1,
  class: "p-the-page-i01"
}
const _hoisted_5 = {
  key: 0,
  class: "p-the-page-i01__header"
}
const _hoisted_6 = {
  key: 0,
  class: "p-the-page-i01__heading"
}
const _hoisted_7 = {
  key: 1,
  class: "p-the-page-i01__heading"
}
const _hoisted_8 = { class: "p-the-page-i01__body" }
const _hoisted_9 = {
  key: 1,
  class: "p-the-page-i01__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_IConditionsList = _resolveComponent("IConditionsList")!
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _component_TheTemplateI = _resolveComponent("TheTemplateI")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateI, {
          search: _ctx.search,
          "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          heading: "付与基準一覧",
          "indicated-item": ['search', 'sorted', 'searchButton'],
          "search-keyword": _ctx.searchKeyword || '',
          "init-shown-search-form-state": _ctx.searchKeyword ? true : false,
          "filter-heading": _ctx.filterHeading,
          sorted: _ctx.sorted,
          onDoSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSearch($event))),
          onDoSort: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doSort($event)))
        }, {
          contents: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoadingContent, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.searchKeyword || _ctx.searchResultCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.headingForSearch)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.headingForSearch), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_IConditionsList, { "conditions-list": _ctx.conditionsList }, null, 8, ["conditions-list"])
                  ]),
                  (_ctx.showPageNavi)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_PageNavi, {
                          "current-page": _ctx.currentPage,
                          "max-page": _ctx.maxPage,
                          "next-page-url": _ctx.nextPageUrl,
                          "prev-page-url": _ctx.prevPageUrl,
                          "base-url": _ctx.baseUrl
                        }, null, 8, ["current-page", "max-page", "next-page-url", "prev-page-url", "base-url"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        }, 8, ["search", "search-keyword", "init-shown-search-form-state", "filter-heading", "sorted"])
      ])
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}